/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $RoomGuardianAngel = {
    properties: {
        id: {
    type: 'number',
    isRequired: true,
},
        name: {
    type: 'string',
    isRequired: true,
},
        primary: {
    type: 'number',
    isRequired: true,
},
    },
};